import React, { useRef } from 'react'
import { useClickAway } from 'react-use'

function Modal({ children, isVisible = false, setIsVisible }) {
  const refModalContent = useRef(null)
  useClickAway(refModalContent, () => setIsVisible(false))

  return (
    <div
      className={`${isVisible ? 'visible' : 'invisible'}
      fixed inset-0 z-50`}
    >
      <div
        className={`relative flex size-full items-center justify-center p-4 ${
          isVisible
            ? 'bg-gray-500/75 backdrop-blur-sm transition-all duration-200 ease-in-out'
            : 'bg-gray-500/0'
        }`}
      >
        <button
          className={`absolute right-4 top-4 rounded-md bg-gray-700 px-3 py-1.5 text-sm font-medium text-gray-50 ${
            isVisible ? 'block' : 'hidden'
          }`}
          onClick={() => setIsVisible(false)}
        >
          close
        </button>
        <div
          ref={refModalContent}
          className={`w-full max-w-4xl rounded-xl bg-white p-1 shadow-md shadow-gray-600 ${
            isVisible
              ? 'translate-y-0 scale-100 opacity-100 transition-all duration-200 ease-in-out'
              : 'translate-y-4 scale-95 opacity-0'
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
